import type {
  CampaignAnalysisHistoryItem,
  CampaignAnalysisHistoryResponse,
  CampaignAnalysisStatus,
  CampaignAnalysisTargetMetric,
} from '@/entities/campaign/generated/campaign-type';

const targetMetricLabels: Record<CampaignAnalysisTargetMetric, string> = {
  engagement_score: 'Engagement score',
  view_score: 'View score',
};

const statusLabels: Record<CampaignAnalysisStatus, string> = {
  completed: 'Completed',
  failed: 'Failed',
  processing: 'Processing',
  requesting: 'Requesting',
};

export function mergeCampaignAnalysisHistoryPages(
  pages: readonly CampaignAnalysisHistoryResponse[] | undefined,
) {
  const runsById = new Map<string, CampaignAnalysisHistoryItem>();

  pages?.forEach((page) => {
    page.items.forEach((run) => {
      if (!runsById.has(run.run_id)) {
        runsById.set(run.run_id, run);
      }
    });
  });

  return Array.from(runsById.values());
}

export function getCampaignAnalysisRunTitle(run: CampaignAnalysisHistoryItem) {
  return run.title ?? `${getCampaignAnalysisTargetMetricLabel(run.target_metric)} report`;
}

export function getCampaignAnalysisTargetMetricLabel(targetMetric: CampaignAnalysisTargetMetric) {
  return targetMetricLabels[targetMetric];
}

export function getCampaignAnalysisStatusLabel(status: CampaignAnalysisStatus) {
  return statusLabels[status];
}
